import { createStore, applyMiddleware  } from 'redux';
import PostMessagesMiddleware from './post-messages.middleware';
import PostMessagesReducer from './post-messages.reducers';
import * as PostMessagesActions from './post-messages.actions.js';

const middlewareEnhancers = applyMiddleware(PostMessagesMiddleware );
let store = createStore(PostMessagesReducer,middlewareEnhancers)

export { store, PostMessagesActions }
